import React from "react";
import nspa1 from "../../../images/nspa1.jpg";
import nspa2 from "../../../images/nspa2.jpg";
import nspa3 from "../../../images/nspa3.jpg";
import nspa4 from "../../../images/nspa4.jpg";
import EngagementCarouselPage from "../../ui/EngagementCarouselPage";

const KindnessMusic = () => (
  <EngagementCarouselPage
    title="Kindness in Music – NSPA"
    paragraphs={[
      "There's no better way to tell the kindness story than through song, so in the debut year of the Equal Streets Initiative, Kindness Unlimited collaborated with the National Streets of Performing Arts, a NPO dedicated to bringing culture back to the streets, whose artists not only filled the air with moving renditions, but also got us all to celebrate the joy of being good!",
    ]}
    images={[nspa1, nspa2, nspa3, nspa4]}
  />
);

export default KindnessMusic;
